const icon = require('vue-svgicon');
icon.register({
    'pen': {
        width: 24,
        height: 24,
        viewBox: '0 0 256 256',
        data: `<path pid="0" d="M248 92.68a15.86 15.86 0 00-4.69-11.31l-68.68-68.69a16 16 0 00-22.63 0l-28.43 28.43-58 21.77a16.06 16.06 0 00-10.22 12.35L32.11 214.68A8 8 0 0040 224a8.4 8.4 0 001.32-.11l139.44-23.24a16 16 0 0012.35-10.17l21.77-58L243.31 104A15.87 15.87 0 00248 92.68zm-69.87 92.19L63.32 204l47.37-47.37a28 28 0 10-11.32-11.32L52 192.7 71.13 77.86 126 57.29 198.7 130zM112 132a12 12 0 1112 12 12 12 0 01-12-12zm96-15.32L139.31 48l24-24L232 92.68z"/>`,
    },
});
